import React from "react";
import Entities from "../../components/Entities";

function Stores() {
  return (
    <Entities
      shema={{
        searchFromServer: true,
        searchRoute: "stores",
        fields: [
          {
            name: "Name",
            propertyName: "name",
            search: true,
          },
          {
            name: "Store No",
            propertyName: "number",
            search: true,
          },
          {
            name: "Visit Frequency",
            propertyName: "visitFrequency",
          },
          {
            name: "Address",
            propertyName: ["civicNo", "street", "city"],
          },
          {
            name: "Territory",
            propertyName: "territory",
            isObject: true,
            filter: true,
            filterRoute: "territories",
          },
        ],
      }}
    />
  );
}

export default Stores;
